// extracted by mini-css-extract-plugin
export default {"answerDiv":"MarkExam_answerDiv__pxKkx"};